// src/Components/Drawer/InfoTab/InfoTabControls.js

import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../../Firebase/firebase';

const sanitizeForFirestore = (data) => {
  const clean = { ...data };
  Object.keys(clean).forEach((key) => {
    const val = clean[key];
    if (val === undefined) {
      clean[key] = null;
    } else if (val instanceof File || val instanceof FileList) {
      delete clean[key];
    }
  });
  return clean;
};

export class InfoTabControls {
  constructor(setIsEditing, setTempData, originalData) {
    this.setIsEditing = setIsEditing;
    this.setTempData = setTempData;
    this.originalData = originalData;
  }

  handleEdit() {
    this.setIsEditing(true);
  }

  handleCancel() {
    this.setIsEditing(false);
    if (this.originalData) {
      this.setTempData(this.originalData);
    }
  }

  // NOTE: The main save logic is now often handled by useDrawerLogic.js
  // ensuring centralized state management. This method is kept for specific contexts.
  async handleSave(currentData) {
    if (!currentData || (!currentData.id && !currentData.markerGroupID)) {
      console.error('ERROR: No valid data/ID received! Cannot save to Firestore.');
      return;
    }

    try {
      const groupId = currentData.markerGroupID || currentData.id;

      const dataToSave = {
        ...currentData,
        lastModified: new Date().toISOString(),
      };

      const cleanData = sanitizeForFirestore(dataToSave);

      // Prevent geometry fields from being written into the markerGroups collection
      delete cleanData.position;
      delete cleanData.path;
      delete cleanData.paths;
      delete cleanData.isNew;

      await setDoc(doc(db, 'markerGroups', groupId), cleanData, { merge: true });

      console.log(`[InfoTabControls] Successfully saved to markerGroups/${groupId}`);

      this.originalData = cleanData;
      this.setIsEditing(false);
    } catch (error) {
      console.error('[InfoTabControls] Error saving to Firestore:', error);
      // REMOVED NATIVE ALERT: Logic should handle errors via UI state if needed.
    }
  }

  // NOTE: Delete Confirmation is now handled by DrawerAlerts.js via useDrawerLogic.js
  // This method is deprecated to prevent native alerts.
  handleDelete(onConfirm) {
    // REMOVED NATIVE WINDOW.CONFIRM to avoid square buttons.
    // If this method is called, we assume the UI confirmation has already occurred.
    if (onConfirm) {
      onConfirm();
    }
  }
}
